import React, { useEffect } from 'react';
import {useLocation} from "react-router-dom";
import ReactModal from 'react-modal';
import ReactTooltip from 'react-tooltip';
import { roomlabelApi } from '../../../apis/roomlabel/roomlabelApi';
import { getLabelColor } from '../../../libs/utils/getLabelColor';
import icon05 from '../../../assets/images/ROOM_TaskFile_Re_05.png';
import useLoading from '../../../hooks/useLoading';
import { LabelList } from '../../../types/types';
import {logError} from "../../../libs/utils/logError";
import useAppRouter from "../../../hooks/useAppRouter";

interface SelectLabelModalProps {
  labels: LabelList[];
  setLabels: React.Dispatch<React.SetStateAction<LabelList[]>>;
  setShowLabelModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SelectLabelModal = (props: SelectLabelModalProps) => {
  const withLoading = useLoading();
  const location = useLocation();
  const { goto } = useAppRouter();
  const { labels, setLabels, setShowLabelModal } = props;
  const [labelLists, setLabelLists] = React.useState<LabelList[]>([]);
  const [tempLabels, setTempLabels] = React.useState<LabelList[]>(labels);

  useEffect(() => {
    const fetch = async () => {
      withLoading(async () => {
        try {
          const response = await roomlabelApi.index({});
          setLabelLists(response.labelList);
        } catch(e) {
          await logError(
            location.pathname,
            'ラベル一覧の取得に失敗しました。',
            e
          );

          goto('internalServerError');
        }
      });
    };
    fetch();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  const handleChange = (label: LabelList) => {
    if (tempLabels.some((tl) => tl.id === label.id)) {
      setTempLabels(tempLabels.filter((l) => l.id !== label.id));
    } else {
      setTempLabels(
        tempLabels.concat({
          id: label.id,
          name: label.name,
          color: label.color,
        })
      );
    }
  };

  const handleSubmit = () => {
    setTempLabels((prevState) => prevState.sort((a, b) => a.id - b.id));
    setLabels(tempLabels);
    setShowLabelModal(false);
  };

  return (
    <>
      <ReactModal
        isOpen
        ariaHideApp={false}
        onRequestClose={() => setShowLabelModal(false)}
        className="content"
        overlayClassName="overlay"
        shouldCloseOnOverlayClick
      >
        <div className="form-modal-container">
          <div className="form-modal-title">
            <h1 className="font-semibold">ラベル指定</h1>
            <button
              type="button"
              className="modal-close-btn"
              onClick={() => setShowLabelModal(false)}
            >
              <img src={icon05} alt="icon" />
            </button>
          </div>
          <div className="px-4 pt-8">
            <div className="px-2 grid grid-cols-2 gap-4">
              {tempLabels.length === 0 ? (
                <label htmlFor="task-label" className="btn-radio-pill-checked">
                  ラベル指定なし
                  <input
                    id="task-label"
                    type="checkbox"
                    className="hidden"
                    checked
                    onChange={() => setTempLabels([])}
                  />
                </label>
              ) : (
                <label htmlFor="task-label" className="btn-radio-pill">
                  ラベル指定なし
                  <input
                    id="task-label"
                    type="checkbox"
                    className="hidden"
                    checked={false}
                    onChange={() => setTempLabels([])}
                  />
                </label>
              )}
            </div>
            <div className="border border-primary my-8 border-opacity-50" />
            <div className="px-2 grid grid-cols-2 gap-4">
              {labelLists.map((ll) =>
                tempLabels.some((tl) => tl.id === ll.id) ? (
                  <label
                    key={ll.id}
                    htmlFor={`task-label${ll.id}`}
                    className="flex"
                  >
                    <div
                      data-tip={ll.name}
                      data-for={`label-${ll.id}`}
                      className={`btn-checkbox-rounded-checked ${getLabelColor(
                        ll.color
                      )}`}
                    >
                      <div className="w-32 truncate">{ll.name}</div>
                    </div>
                    <ReactTooltip
                      place="top"
                      type="dark"
                      effect="solid"
                      id={`label-${ll.id}`}
                      className="max-w-xs break-all text-xs"
                    />
                    <input
                      id={`task-label${ll.id}`}
                      type="checkbox"
                      className="hidden"
                      checked
                      value={ll.id}
                      onChange={() => handleChange(ll)}
                    />
                  </label>
                ) : (
                  <label
                    key={ll.id}
                    htmlFor={`task-label${ll.id}`}
                    className="flex"
                  >
                    <div
                      data-tip={ll.name}
                      data-for={`label-${ll.id}`}
                      className="btn-checkbox-rounded"
                    >
                      <div className="w-32 truncate">{ll.name}</div>
                    </div>
                    <ReactTooltip
                      place="top"
                      type="dark"
                      effect="solid"
                      id={`label-${ll.id}`}
                      className="max-w-xs break-all text-xs"
                    />
                    <input
                      id={`task-label${ll.id}`}
                      type="checkbox"
                      className="hidden"
                      checked={false}
                      value={ll.id}
                      onChange={() => handleChange(ll)}
                    />
                  </label>
                )
              )}
            </div>
            <div className="border border-primary mt-16 border-opacity-50" />
          </div>
          <div className="form-modal-footer-container">
            <div className="form-modal-footer">
              <button
                className="btn-sub"
                type="button"
                onClick={() => setShowLabelModal(false)}
              >
                キャンセル
              </button>
              <button
                className="btn-primary"
                type="button"
                onClick={handleSubmit}
              >
                保 存
              </button>
            </div>
          </div>
        </div>
      </ReactModal>
    </>
  );
};
